import { render } from "./Bottom_navigation.vue?vue&type=template&id=4369dbbf&scoped=true&ts=true"
import script from "./Bottom_navigation.vue?vue&type=script&lang=ts"
export * from "./Bottom_navigation.vue?vue&type=script&lang=ts"

import "./Bottom_navigation.vue?vue&type=style&index=0&id=4369dbbf&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4369dbbf"]])

export default __exports__